import {Dimension} from '../types';

export function hideSidebar() {
	const icon = document.getElementById('kt_app_sidebar_toggle');

	if (icon?.classList.contains('active')) return;

	icon?.click();
}

export function getCSSVariableValue(variableName: string) {
	let hex = getComputedStyle(document.documentElement).getPropertyValue(variableName);
	if (hex && hex.length > 0) {
		hex = hex.trim();
	}

	return hex;
}

export const isMobile = () => {
	return window.matchMedia('(max-width:420px)').matches;
};

export const isSquare = ({height, width}: Dimension) => {
	return height === width;
};

export const getInputValueByName = (name: string) => {
	return (document.querySelector(`input[name="${name}"]`) as HTMLInputElement)?.value ?? undefined;
};
